import ViewPDF from "@/components/ViewPDF/viewPDF.component";
import { usePDFGenerator } from "@/hooks/usePDFGenerator";
import { Button } from "@/shadcn/components/ui/button";
import { FullSingleQuote } from "@/types";
import React, { useState } from "react";

interface QuotePDFActionsProps {
  quote: FullSingleQuote;
}

/**
 * Component that provides PDF generation actions for quotes
 * Demonstrates how to use the PDF generation utilities
 */
const QuotePDFActions: React.FC<QuotePDFActionsProps> = ({ quote }) => {
  const [showPDF, setShowPDF] = useState(false);
  const [pdfBase64, setPdfBase64] = useState<string>("");

  const { generatePDFAsBase64, downloadPDF, isGenerating, error, clearError } =
    usePDFGenerator();

  // Handle viewing PDF in modal
  const handleViewPDF = async () => {
    clearError();
    const base64String = await generatePDFAsBase64(quote);

    if (base64String) {
      setPdfBase64(base64String);
      setShowPDF(true);
    }
    // Error handling is managed by the hook
  };

  // Close PDF viewer
  const closePDFViewer = () => {
    setShowPDF(false);
    setPdfBase64("");
  };

  return (
    <div className="flex items-center gap-2">
      {/* View PDF Button */}
      <Button
        onClick={handleViewPDF}
        disabled={isGenerating}
        className="mb-4 flex items-center gap-2"
      >
        {/* {isGenerating ? <Loader2 className="h-4 w-4 animate-spin" /> : null} */}
        View PDF
      </Button>

      {/* Error Display */}
      {error && <div className="text-sm text-red-600">{error}</div>}

      {/* PDF Viewer Modal */}
      {showPDF && pdfBase64 && (
        <ViewPDF
          fileBase64={pdfBase64}
          closeViewer={closePDFViewer}
          fileName={quote.quote_number}
        />
      )}
    </div>
  );
};

export default QuotePDFActions;
